import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { PathAssociationRequester } from '@cobliteam/api-lib/src/dashboard/pathAssociation/PathAssociationRequester';
import type { PathAssociation, PathAssociationFilters } from '@cobliteam/api-lib/src/dashboard/pathAssociation/Types';
import type { PageableContent, UUID } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { type UseQueryOptions, keepPreviousData, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();
const pathAssociationRequester = new PathAssociationRequester({ host: env.herbieApiHost });

const QUERY_KEY = 'PATH_ASSOCIATION';

const useGetPathAssociations = (filters: PathAssociationFilters, options?: Partial<UseQueryOptions<PageableContent<PathAssociation>>>) => {
  return useQuery({
    queryKey: [QUERY_KEY, filters],
    queryFn: () => pathAssociationRequester.getPathAssociations(filters),
    placeholderData: keepPreviousData,
    ...options,
  });
};

const useGetPaths = (vehicleId: UUID, startTime: number, endTime: number, associationMethods?: string[], options?: Partial<UseQueryOptions<Path[]>>) => {
  return useQuery({
    queryKey: [QUERY_KEY, 'paths', vehicleId, startTime, endTime, associationMethods],
    queryFn: () => pathAssociationRequester.getPaths(vehicleId, startTime, endTime, associationMethods),
    ...options,
  });
};

export { useGetPathAssociations, useGetPaths };
